(function() {
'use strict';

angular.module('TR')
    .directive('sortButton', sortButton);

function sortButton($timeout, preferences) {
    const opposite = {
        asc: 'desc',
        desc: 'asc'
    };
    return {
        restrict: 'E',
        replace: true,
        scope: {
            model: '=',
            title: '@',
            val: '=',
            id: '=',
            group: '@',
            property: '@',
            active: '=',
            order: '=',
            defaultOrder: '@',
            defaultSort: '@',
            preferenceKey: '@'
        },
        templateUrl: 'partials/home/directivetemplate?type=SortButton',

        link(scope, el) {
            const chk = el.find('input');
            let val;

            preferences.get(scope.preferenceKey).then(function(so) {
                scope.order = scope.defaultOrder;
                if (scope.val.indexOf(so) >= 0) {
                    if (so !== parseInt(scope.defaultSort)) {
                        scope.order = opposite[scope.defaultOrder];
                    }
                }
            });

            function checked(c) {
                chk.prop('checked', c);
                if (c) {
                    scope.active = true;
                } else {
                    scope.active = false;
                }
            }

            // Verifies if we're dealing with an object or a direct value
            function safeCheck(modelValue) {
                if (scope.property) {
                    checked(modelValue[scope.property] === val[scope.property]);
                } else {
                    checked(scope.val.indexOf(modelValue) > -1);
                }
            }

            const canc = scope.$watch('val', function(v) {
                if (v != null) {
                    val = scope.val[0];
                    safeCheck(scope.model);
                    canc();
                }
            });

            scope.$watch('model', function(v) {
                if (v == null) {
                    return;
                }
                safeCheck(v);
            });

            scope.toggle = function(event) {
                // Changes the model only if the value is new, emits the click
                // event anyway.
                const sameSelection = scope.val.indexOf(scope.model) > -1;

                if (!sameSelection) {
                   if (scope.val.length > 1) {
                        scope.model = parseInt(scope.defaultSort);
                    } else {
                        scope.model = scope.val[0];
                    }
                } else if (scope.val.length > 1) {
                    scope.model = scope.model === scope.val[0] ? scope.val[1] : scope.val[0];
                }
                event.preventDefault();
                $timeout(function() { scope.$emit('radio-clicked'); });
            };

            scope.class = function() {
                const cls = {};
                if (scope.active) {
                    cls.active = true;
                }
                if (scope.order) {
                    cls[scope.order] = true;
                }
                return cls;
            };

            scope.$watch('model', function() {
                if (scope.active && scope.model !== parseInt(scope.defaultSort)) {
                    scope.order = opposite[scope.defaultOrder];
                } else {
                    scope.order = scope.defaultOrder;
                }
            });
        }
    };
}
})();
